;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$timeout", "mediaView"];
  angular.module('app.survey').component('surveyQuestionMatrix', {
    controller: Controller,
    templateUrl: 'survey-question-matrix.html',
    bindings: {
      survey: '=',
      question: '=',
    },
  })

  /* @ngInject */
  function Controller($scope, $timeout, mediaView) {
    var ctrl = this
    var arrayCache = {}

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy

    ctrl.setTableElem = setTableElem
    ctrl.isMobile = isMobile
    ctrl.isChoiceLabel = isChoiceLabel
    ctrl.toggleAccordionStatementId = toggleAccordionStatementId
    ctrl.getSelectedText = getSelectedText
    ctrl.expanderHeight = expanderHeight
    ctrl.onSelectionChange = onSelectionChange
    ctrl.getSelectedOptionsForStatement = getSelectedOptionsForStatement
    ctrl.getSelectedTextCaptureChoice = getSelectedTextCaptureChoice
    ctrl.expandImage = expandImage

    ctrl.setupCarousel = setupCarousel
    ctrl.getCarouselStatement = getCarouselStatement
    ctrl.getCarouselImageStyle = getCarouselImageStyle
    ctrl.getCarouselProgressStyle = getCarouselProgressStyle
    ctrl.canCarouselGoPrev = canCarouselGoPrev
    ctrl.canCarouselGoNext = canCarouselGoNext
    ctrl.goCarouselPrev = goCarouselPrev
    ctrl.goCarouselNext = goCarouselNext
    ctrl.toggleCarouselChoice = toggleCarouselChoice

    // table cell methods to ensure passing the correct args when flipped
    ctrl.toggleSelectedCell = toggleSelectedCell
    ctrl.isCellSelected = isCellSelected
    ctrl.canSelectMoreCell = canSelectMoreCell

    ctrl.isChoiceSelectedInOthers = isChoiceSelectedInOthers

    // Drag and Drop methods
    ctrl.setupDnd = setupDnd
    ctrl.getDndImageStyle = getDndImageStyle
    ctrl.getDndScrollStyle = getDndScrollStyle
    ctrl.getDndStatementStyle = getDndStatementStyle
    ctrl.canDndGoPrev = canDndGoPrev
    ctrl.canDndGoNext = canDndGoNext
    ctrl.goDndPrev = goDndPrev
    ctrl.goDndNext = goDndNext
    ctrl.onDndDragOver = onDndDragOver
    ctrl.isDndDragOverChoice = isDndDragOverChoice
    ctrl.isDndChoiceDroppable = isDndChoiceDroppable
    ctrl.canClickDndAddBtn = canClickDndAddBtn
    ctrl.onClickDndAddBtn = onClickDndAddBtn
    ctrl.onDndDrop = onDndDrop
    ctrl.onClickDndSelectedStatement = onClickDndSelectedStatement

    function onInit() {
      ctrl.statements = ctrl.question.getVisibleStatements()
      ctrl.statementsH = ctrl.question.getVisibleStatements(true)
      ctrl.statementBlocks = ctrl.question.getChoicesAsBlocks(ctrl.statementsH)
      ctrl.choices = ctrl.question.getVisibleChoices()
      ctrl.choicesH = ctrl.question.getVisibleChoices(true)
      ctrl.choiceBlocks = ctrl.question.getChoicesAsBlocks(ctrl.choicesH)

      // prepare table data
      if (ctrl.question.flipTableAxis) {
        ctrl.tableChoices = ctrl.statements
        ctrl.tableStatementBlocks = ctrl.choiceBlocks
        ctrl.hasChoiceImages = ctrl.question.hasStatementImages
        ctrl.hasStatementImages = ctrl.question.hasChoiceImages
        ctrl.isChoiceImageAndLabel = ctrl.question.isStatementImageAndLabel
        ctrl.isStatementImageAndLabel = ctrl.question.isChoiceImageAndLabel
      } else {
        ctrl.tableChoices = ctrl.choices
        ctrl.tableStatementBlocks = ctrl.statementBlocks
        ctrl.hasChoiceImages = ctrl.question.hasChoiceImages
        ctrl.hasStatementImages = ctrl.question.hasStatementImages
        ctrl.isChoiceImageAndLabel = ctrl.question.isChoiceImageAndLabel
        ctrl.isStatementImageAndLabel = ctrl.question.isStatementImageAndLabel
      }

      ctrl.choiceOptions = ctrl.choices.map(function(choice) {
        return { value: choice.id, label: choice.option }
      })
      var firstStatement = ctrl.statements[0]
      if (firstStatement) {
        ctrl.accordionStatementId = firstStatement.id
      }

      if (
        ctrl.question.displayType === ctrl.question.MatrixDisplayTypes.SCALE
      ) {
        // scale display type supports one independent choice shown outside the slider
        var independent = _.remove(ctrl.choices, function(choice) {
          return choice.data.isIndependent
        })
        ctrl.independent = independent[0]
        // also remove from other places
        _.remove(ctrl.choicesH, function(choice) {
          return choice.data.isIndependent
        })
        _.each(ctrl.choiceBlocks, function(block) {
          _.remove(block.choices, function(choice) {
            return choice.data.isIndependent
          })
        })
      }

      ctrl.carouselIndex = 0
    }

    function setTableElem() {
      ctrl.tableElem = document.getElementsByClassName(
        'survey-question-matrix__table-wrapper'
      )[0]
    }

    function isMobile() {
      // the 40 here is used to break when there is 20px either side of the table (padding)
      var mobile = ctrl.tableElem.offsetWidth + 40 > document.body.offsetWidth
      return mobile
    }

    function isChoiceLabel(choice, asStatement) {
      var isLabelsHidden = asStatement
        ? ctrl.question.statementLabelsHidden
        : ctrl.question.choiceLabelsHidden
      return !isLabelsHidden || !choice.data.imageUrl
    }

    function toggleAccordionStatementId(statementId) {
      if (ctrl.accordionStatementId === statementId) {
        ctrl.accordionStatementId = null
      } else {
        ctrl.accordionStatementId = statementId
      }
    }

    function getSelectedText(statementId) {
      return (
        ctrl.question.statementAnswers[statementId]
          .map(function(choice) {
            return choice.option
          })
          .join(', ') + ' '
      )
    }

    function expanderHeight() {
      return (
        document.getElementsByClassName(
          'survey-question-matrix__accordion-choices'
        )[0].offsetHeight + 'px'
      )
    }

    function onSelectionChange(value, statement) {
      // value is an array when multi-select, lets normalize to that
      value = _.isArray(value) ? value : [value]

      var selected = ctrl.question.statementAnswers[statement.id]
      var toggledChoiceIds = []
      var isTogglingSingleSelectOption =
        !ctrl.question.isMulti &&
        value.length &&
        selected.length &&
        value[0] === selected[0].id

      // field-select only gives us the whole array of selected id's
      // when it changes so we need to find what has changed and toggle it.

      if (isTogglingSingleSelectOption) {
        toggledChoiceIds.push(value[0])
      }
      _.each(selected, function(choice) {
        var wasDeselected = !_.includes(value, choice.id)
        if (wasDeselected) toggledChoiceIds.push(choice.id)
      })
      _.each(value, function(id) {
        var wasSelected = !_.find(selected, function(choice) {
          return choice.id === id
        })
        if (wasSelected) toggledChoiceIds.push(id)
      })

      // we collect the ids of what has changed above BEFORE we actually
      // toggle them, because the toggling them modifies the selected array
      // resulting in false positives on what actually changed.
      toggledChoiceIds.forEach(function(choiceId) {
        var choice = _.find(ctrl.choices, function(choice) {
          return choice.id === choiceId
        })
        ctrl.question.toggleSelected(choice, statement)
      })
    }

    function getSelectedOptionsForStatement(statement) {
      // returns an array of choice id's that are selected
      // for this statement.
      var options = _.filter(ctrl.choices, function(choice) {
        return ctrl.question.isSelected(choice, statement)
      }).map(function(choice) {
        return choice.id
      })
      // we use an equality-cache that returns the exact
      // same array reference if the results are the same.
      // this prevents infinite loops with angular digests
      // and means we don't have to maintain 2 different
      // arrays and keep them in sync.
      var key = options.join('')
      var array = arrayCache[key]
      if (!array) array = arrayCache[key] = options
      return array
    }

    function getSelectedTextCaptureChoice(statement) {
      // currently we only support 1 choice text capture per statement
      // so just return the first item
      return ctrl.question.getSelectedTextCaptures(statement)[0]
    }

    function expandImage(event, imageUrl) {
      if (!imageUrl) return
      event.preventDefault()
      event.stopPropagation()
      mediaView.showImage(imageUrl)
    }

    function toggleSelectedCell(choice, statement) {
      if (ctrl.question.flipTableAxis) {
        ctrl.question.toggleSelected(statement, choice)
      } else {
        ctrl.question.toggleSelected(choice, statement)
      }
    }

    function isCellSelected(choice, statement) {
      if (ctrl.question.flipTableAxis) {
        return ctrl.question.isSelected(statement, choice)
      } else {
        return ctrl.question.isSelected(choice, statement)
      }
    }

    function canSelectMoreCell(choice, statement) {
      if (ctrl.question.flipTableAxis) {
        return ctrl.question.canSelectMore(choice)
      } else {
        return ctrl.question.canSelectMore(statement)
      }
    }

    function isChoiceSelectedInOthers(choice, statement) {
      return _.some(ctrl.statements, function(item) {
        return (
          statement.id !== item.id && ctrl.question.isSelected(choice, item)
        )
      })
    }

    function setupCarousel() {
      window.addEventListener('resize', updateCarousel)
      updateCarousel()
      ctrl.resizeListener = true
    }

    function updateCarousel() {
      $scope.$applyAsync(function() {
        var container = document.getElementsByClassName(
          'survey-question-matrix__carousel-statements'
        )[0]
        ctrl.carouselStatementWidth = container.offsetWidth
      })
    }

    function getCarouselStatement() {
      return ctrl.statements[ctrl.carouselIndex]
    }

    function getCarouselImageStyle(statement) {
      var url = statement.data.imageUrl
      return { backgroundImage: 'url(' + url + ')' }
    }

    function getCarouselProgressStyle() {
      return {
        width: ((ctrl.carouselIndex + 1) / ctrl.statements.length) * 100 + '%',
      }
    }

    function canCarouselGoPrev() {
      return ctrl.carouselIndex > 0
    }

    function canCarouselGoNext() {
      return ctrl.carouselIndex < ctrl.statements.length - 1
    }

    function goCarouselPrev() {
      if (!canCarouselGoPrev()) return
      ctrl.carouselIndex--
    }

    function goCarouselNext() {
      if (!canCarouselGoNext()) return
      ctrl.carouselIndex++
    }

    function toggleCarouselChoice(choice) {
      var statement = ctrl.getCarouselStatement()
      ctrl.question.toggleSelected(choice, statement)
      var isSelected = ctrl.question.isSelected(choice, statement)
      var isSingleSelect = ctrl.question.maxSelections === 1
      if (isSelected && isSingleSelect && !choice.data.isCapture) {
        $timeout(function() {
          goCarouselNext()
        }, 100)
      }
    }

    function setupDnd() {
      ctrl.dndIndex = 0
      // Filter out selected statements for matrix DnD (max selection is always 1)
      ctrl.dndStatements = _.filter(ctrl.statements, function(statement) {
        return !ctrl.question.statementAnswers[statement.id].length
      })
      ctrl.dndResizeListener = true
      window.addEventListener('resize', updateDnd)
      updateDnd()
      generateDndSelectedRows()
    }

    function updateDnd() {
      $scope.$applyAsync(function() {
        var container = document.getElementsByClassName(
          'survey-question-matrix__dnd-statements'
        )[0]
        ctrl.dndStatementWidth = container.offsetWidth
      })
    }

    function getDndImageStyle(choiceOrStatement, replaceWithGreyBox) {
      if (!choiceOrStatement.data.imageUrl) {
        return replaceWithGreyBox ? { background: 'rgba(0,0,0, 0.05)' } : null
      }
      return {
        'background-image': 'url(' + choiceOrStatement.data.imageUrl + ')',
      }
    }

    function getDndScrollStyle() {
      return {
        left: -(ctrl.dndIndex * ctrl.dndStatementWidth) + 'px',
      }
    }

    function getDndStatementStyle() {
      return { 'min-width': ctrl.dndStatementWidth + 'px' }
    }

    function canDndGoPrev() {
      return ctrl.dndIndex !== 0 && ctrl.dndStatements.length > 0
    }

    function canDndGoNext() {
      return (
        ctrl.dndIndex !== ctrl.dndStatements.length - 1 &&
        ctrl.dndStatements.length > 0
      )
    }

    function goDndPrev() {
      if (!ctrl.canDndGoPrev()) return
      ctrl.dndIndex--
    }

    function goDndNext() {
      if (!ctrl.canDndGoNext()) return
      ctrl.dndIndex++
    }

    function onDndDragOver(targetId) {
      ctrl.currentDragOverChoiceId = targetId
    }

    function isDndDragOverChoice(choice) {
      return ctrl.currentDragOverChoiceId === choice.id
    }

    function isDndChoiceDroppable(choice) {
      if (!ctrl.question.matrixUniqueSelection) return true

      // if it's unique selection, ensure choice hasn't been selected
      return !_.some(ctrl.statements, function(statement) {
        return ctrl.question.isSelected(choice, statement)
      })
    }

    function canClickDndAddBtn(choice) {
      return ctrl.dndStatements.length > 0 && isDndChoiceDroppable(choice)
    }

    function onClickDndAddBtn(choice) {
      var statement = ctrl.dndStatements[ctrl.dndIndex]
      handleDndChoiceSelection(choice, statement)
    }

    function onDndDrop(targetId, statement) {
      var targetChoice = _.find(ctrl.choices, { id: targetId })
      handleDndChoiceSelection(targetChoice, statement)
    }

    function onClickDndSelectedStatement(choice, statement) {
      handleDndChoiceDeselection(choice, statement)
    }

    function handleDndChoiceSelection(choice, statement) {
      if (ctrl.question.isSelected(choice, statement)) {
        return
      }
      // select choice
      ctrl.question.toggleSelected(choice, statement)
      // store the selectedTime for sorting
      statement.data.selectedTime = new Date().getTime()
      // remove statement from window and refresh dndIndex
      ctrl.dndStatements.splice(ctrl.dndIndex, 1)
      if (ctrl.dndIndex > ctrl.dndStatements.length - 1) {
        ctrl.dndIndex = ctrl.dndStatements.length - 1
      }
      generateDndSelectedRows()
    }

    function handleDndChoiceDeselection(choice, statement) {
      if (!ctrl.question.isSelected(choice, statement)) {
        return
      }
      // deselect choice
      ctrl.question.toggleSelected(choice, statement)
      // clear the statement selectedTime
      statement.data.selectedTime = null
      // add statement back to window and refresh dndIndex
      ctrl.dndStatements.push(statement)
      if (ctrl.dndIndex === -1) {
        ctrl.dndIndex = 0
      }
      generateDndSelectedRows()
    }

    function generateDndSelectedRows() {
      // group selected statements by choice
      var choiceMap = ctrl.choices.reduce(function(map, choice) {
        map[choice.id] = ctrl.statements
          .filter(function(statement) {
            return ctrl.question.isSelected(choice, statement)
          })
          .sort(function(statementA, statementB) {
            return statementA.data.selectedTime - statementB.data.selectedTime
          })
        return map
      }, {})

      // find the longest array of selected statements
      var rowsLength = _.maxBy(_.values(choiceMap), function(statements) {
        return statements.length
      }).length

      // generate rows of selected statements
      ctrl.dndSelectedRows = Array.from({ length: rowsLength }, function(
        x,
        index
      ) {
        return ctrl.choices.reduce(function(obj, choice) {
          obj[choice.id] = choiceMap[choice.id][index] || null
          // force ng-repeat re-render with unique timestamp per row
          obj.timestamp = new Date().getTime() + index
          return obj
        }, {})
      })
    }

    function onDestroy() {
      if (ctrl.resizeListener) {
        window.removeEventListener('resize', updateCarousel)
      }
      if (ctrl.dndResizeListener) {
        window.removeEventListener('resize', updateDnd)
      }
    }
  }
})()
